import React, { Component } from "react";
import firebase from "../../firebase";
import { Link } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import { withStyles } from "@material-ui/core/styles";

const styles = {
  card: {
    minWidth: 275
  }
};

class Dashboard extends Component {
  state = {
    pageCount: null,
    imageCount: null,
    userCount: 2
  };

  componentDidMount() {
    let pages = firebase.database().ref("pages");
    let tempPg = [];
    pages.on("value", snap => {
      let val = snap.val();
      for (let pg of val) {
        if (pg) {
          tempPg.push(pg);
        }
      }
      this.setState({ pageCount: tempPg.length });
    });
    let images = firebase.database().ref("images");
    let tempArr = [];
    images.on("value", snap => {
      let val = snap.val();
      for (let item of val) {
        if (item) {
          tempArr.push(item);
        }
      }
      this.setState({ imageCount: tempArr.length });
    });
  }

  componentWillUnmount() {
    firebase
      .database()
      .ref()
      .off();
  }

  render() {
    const { classes } = this.props;
    return (
      <section className="admin-dashboard-content">
        <article className="dashboard-analytics">
          <div className="info-container">
            <Card className={`${classes.card} card`}>
              <CardContent className="card-content">
                <i className="far fa-file" />
                <h2>Pages</h2>
                <Divider className="card-divider" light={true} />
                <div className="card-details">
                  <p>Total Pages: {this.state.pageCount}</p>
                  <Link className="card-cta" to="/admin/pages">
                    view all pages
                  </Link>
                </div>
              </CardContent>
            </Card>
            <Card className={`${classes.card} card`}>
              <CardContent className="card-content">
                <i className="far fa-image" />
                <h2>Images</h2>
                <Divider className="card-divider" light={true} />
                <div className="card-details">
                  <p>Total Images: {this.state.imageCount} / 100</p>
                  <Link className="card-cta" to="/admin/images">
                    view all images
                  </Link>
                </div>
              </CardContent>
            </Card>
            <Card className={`${classes.card} card`}>
              <CardContent className="card-content">
                <i className="fas fa-users" />
                <h2>Users</h2>
                <Divider className="card-divider" light={true} />
                <div className="card-details">
                  <p>Total users: {this.state.userCount}</p>
                  <a
                    className="card-cta"
                    href="mailto:antonio@minervawebdevelopment.com"
                  >
                    Request new user
                  </a>
                </div>
              </CardContent>
            </Card>
          </div>
        </article>
      </section>
    );
  }
}
export default withStyles(styles)(Dashboard);



// WEBPACK FOOTER //
// ./src/admin/pages/Dashboard.js